/**
 * Get a unique ID that is randomized
 * @param  {String} id
 * @return {String} uniqueId
 */
export default function getUniqueId(id) {
  return id + "-" + Math.floor( Math.random() * 9999 );
}
